import React, { useEffect, useState } from 'react';
import { XIcon, UserIcon, SettingsIcon, LogOutIcon, CreditCardIcon, ExternalLinkIcon } from 'lucide-react';
interface UserMenuProps {
  onClose: () => void;
}
export const UserMenu = ({
  onClose
}: UserMenuProps) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center" data-id="element-678">
        <div className="bg-[#282828] rounded-lg w-full max-w-sm mx-4 overflow-hidden" data-id="element-679">
          <div className="p-4 border-b border-white/10 flex items-center justify-between" data-id="element-680">
            <h2 className="text-xl font-bold" data-id="element-681">Account</h2>
            <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-682">
              <XIcon className="w-6 h-6" data-id="element-683" />
            </button>
          </div>
          <div className="p-4 border-b border-white/10" data-id="element-684">
            <div className="flex items-center" data-id="element-685">
              <div className="bg-[#333] rounded-full p-2 mr-3" data-id="element-686">
                <UserIcon className="w-6 h-6 text-gray-300" data-id="element-687" />
              </div>
              <div data-id="element-688">
                <div className="font-medium" data-id="element-689">User Name</div>
                <div className="text-sm text-gray-400" data-id="element-690">user@example.com</div>
              </div>
            </div>
          </div>
          <div className="py-2" data-id="element-691">
            <MenuItem icon={<UserIcon className="w-5 h-5" data-id="element-693" />} label="Profile" data-id="element-692" />
            <MenuItem icon={<CreditCardIcon className="w-5 h-5" data-id="element-695" />} label="Account" data-id="element-694" />
            <MenuItem icon={<SettingsIcon className="w-5 h-5" data-id="element-697" />} label="Settings" data-id="element-696" />
            <MenuItem icon={<ExternalLinkIcon className="w-5 h-5" data-id="element-699" />} label="Support" external data-id="element-698" />
            <MenuItem icon={<LogOutIcon className="w-5 h-5" data-id="element-701" />} label="Log out" onClick={onClose} data-id="element-700" />
          </div>
        </div>
      </div>;
  }
  return <div className="fixed top-16 right-8 z-50" data-id="element-702">
      <div className="bg-[#282828] rounded-lg shadow-xl w-64 overflow-hidden" data-id="element-703">
        <div className="p-4 border-b border-white/10" data-id="element-704">
          <div className="flex items-center" data-id="element-705">
            <div className="bg-[#333] rounded-full p-2 mr-3" data-id="element-706">
              <UserIcon className="w-6 h-6 text-gray-300" data-id="element-707" />
            </div>
            <div data-id="element-708">
              <div className="font-medium" data-id="element-709">User Name</div>
              <div className="text-sm text-gray-400" data-id="element-710">user@example.com</div>
            </div>
          </div>
        </div>
        <div className="py-1" data-id="element-711">
          <MenuItem icon={<UserIcon className="w-5 h-5" data-id="element-713" />} label="Profile" data-id="element-712" />
          <MenuItem icon={<CreditCardIcon className="w-5 h-5" data-id="element-715" />} label="Account" data-id="element-714" />
          <MenuItem icon={<SettingsIcon className="w-5 h-5" data-id="element-717" />} label="Settings" data-id="element-716" />
          <MenuItem icon={<ExternalLinkIcon className="w-5 h-5" data-id="element-719" />} label="Support" external data-id="element-718" />
          <MenuItem icon={<LogOutIcon className="w-5 h-5" data-id="element-721" />} label="Log out" onClick={onClose} data-id="element-720" />
        </div>
      </div>
    </div>;
};
interface MenuItemProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  external?: boolean;
}
const MenuItem = ({
  icon,
  label,
  onClick,
  external
}: MenuItemProps) => <button className="flex items-center w-full px-4 py-3 hover:bg-white/10 transition-colors text-left" onClick={onClick} data-id="element-722">
    <span className="mr-3 text-gray-300" data-id="element-723">{icon}</span>
    <span data-id="element-724">{label}</span>
    {external && <ExternalLinkIcon className="w-4 h-4 ml-auto text-gray-400" data-id="element-725" />}
  </button>;